import { FC } from "react";
import { OddPrice } from "../../../../components/Typography";
import { convertHDP } from "../../../../utils/convertHDP";
import { convertOdds } from "../../../../utils/convertOdds";
import { useChangeDetector } from "../../../../hooks/useOddChangeDetector/useChangeDetector";
import classNames from "classnames";
import Marquee from "react-fast-marquee";

type MarketButtonProps = {
  data: any;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
  isDisplayPlus?: boolean;
  oddsType?: number;
};

const MarketButton: FC<MarketButtonProps> = ({
  data,
  onClick = () => {},
  className,
  isActive,
  isDisplayPlus = true,
  oddsType = 0,
}) => {
  const { priceChangedType } = useChangeDetector(data.price, data.hdp);

  return (
    <button
      onClick={onClick}
      className={classNames(
        "p-0.5 flex flex-col flex-1 border rounded-lg overflow-auto items-center",
        className,
        {
          "bg-yellow-300": isActive,
        }
      )}
      disabled={data.spd}>
      {!!data.label && (
        <p
          className="text-xs truncate"
          style={{
            color: "rgb(47, 128, 237)",
          }}>
          {data.label.length > 18 ? (
            <Marquee gradient={false} pauseOnHover speed={40}>
              {data.label}
            </Marquee>
          ) : (
            data.label
          )}
        </p>
      )}
      {!!data.hdp && (
        <div
          className="text-xs"
          style={{
            color: "rgb(47, 128, 237)",
          }}>
          {convertHDP(data.hdp, isDisplayPlus)}
        </div>
      )}
      <div className="text-sm relative">
        {data.spd ? (
          "-"
        ) : (
          <OddPrice
            isDecrease={priceChangedType === "decrease"}
            isIncrease={priceChangedType === "increase"}
            isRedOdd={convertOdds(data.price, oddsType).includes("-")}>
            {convertOdds(data.price, oddsType)}
          </OddPrice>
        )}
      </div>
    </button>
  );
};

export default MarketButton;
